@if( showMatMenu ){
  @if( checkIsCurrentNotPlaying2 ){
    <button type="button" mat-menu-item pTooltip="Play {{ label }}"
      tooltipPosition="bottom" (click)="mediaPlayerService.playAudio(currentChant, currentChantDeperanceList, playOnClick)"
      [disabled]="mediaPlayerService.streamState.error" >
        <app-feather-icons [icon]="'play'" [class]="'user-menu-icons'" ></app-feather-icons>
        <span class="labelTitle">{{ label }}</span>
        <span *ngIf="label1!==''" class="labelSousTitle"> / {{ label1 }}</span>
        <span *ngIf="label2!==''" class="labelSousTitle"> / {{ label2 }}</span>
    </button>
  }@else{
    @if( checkIsNotPlaying ){
      <button type="button" mat-menu-item pTooltip="Play {{ label }}"
        tooltipPosition="bottom" (click)="mediaPlayerService.playAudio(currentChant, currentChantDeperanceList, playOnClick)"
        [disabled]="mediaPlayerService.streamState.error">
        <app-feather-icons [icon]="'play'" [class]="'user-menu-icons'" ></app-feather-icons>
        <span class="labelTitle">{{ label }}</span>
        <span *ngIf="label1!==''" class="labelSousTitle"> / {{ label1 }}</span>
        <span *ngIf="label2!==''" class="labelSousTitle"> / {{ label2 }}</span>
      </button>
    }@else{
      <button type="button" mat-menu-item *ngIf="mediaPlayerService.streamState?.playing" pTooltip="Pause {{ label }}" tooltipPosition="bottom"
        (click)="mediaPlayerService.pause(playOnClick)" >
        <app-feather-icons [icon]="'pause'" [class]="'user-menu-icons'" ></app-feather-icons>
        <span class="labelTitle">{{ label }}</span>
        <span *ngIf="label1!==''" class="labelSousTitle"> / {{ label1 }}</span>
        <span *ngIf="label2!==''" class="labelSousTitle"> / {{ label2 }}</span>
      </button>
    }
  }
}

@if( !showMatMenu ){
  @if( checkIsCurrentNotPlaying ){
    <button type="button" class="btnicon btn" pTooltip="Play"
    tooltipPosition="bottom" (click)="mediaPlayerService.playAudio(currentChant, currentChantDeperanceList, playOnClick)"
    [disabled]="mediaPlayerService.streamState.error" >
      <app-feather-icons *ngIf="faIcon===''" [icon]="'play'" [class]="'user-menu-icons'" ></app-feather-icons>
      <i *ngIf="faIcon!==''" class="{{faIcon}} user-menu-icons" ></i>
    </button>
  }@else{
    @if( checkIsNotPlaying ){
      <button type="button" class="btnicon btn" pTooltip="Play"
      tooltipPosition="bottom" (click)="mediaPlayerService.playAudio(currentChant, currentChantDeperanceList, playOnClick)"
      [disabled]="mediaPlayerService.streamState.error">
        <app-feather-icons [icon]="'play'" [class]="'user-menu-icons'" ></app-feather-icons>
      </button>
    }@else{
      <buttonb type="button" class="btnicon btn" *ngIf="mediaPlayerService.streamState?.playing" pTooltip="Pause" tooltipPosition="bottom" (click)="mediaPlayerService.pause(playOnClick)" >
        <app-feather-icons [icon]="'pause'" [class]="'user-menu-icons'" ></app-feather-icons>
      </buttonb>
    }
  }
}
